module.exports = __webpack_public_path__ + "img/html.a77c74a2.svg";